import { Component, Input, OnInit } from '@angular/core';
import { StarRatingModule } from 'angular-star-rating';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.scss'],
  standalone: true,
  imports: [StarRatingModule, CommonModule],
})
export class ReviewsComponent implements OnInit {
  constructor() {}

  @Input() rating: any;
  total: number = 0;

  ngOnInit(): void {
    if (this.rating?.review_breakdown) {
      this.total =
        this.rating?.review_breakdown?.['1_star'] +
        this.rating?.review_breakdown?.['2_stars'] +
        this.rating?.review_breakdown?.['3_stars'] +
        this.rating?.review_breakdown?.['4_stars'] +
        this.rating?.review_breakdown?.['5_stars'];
    }
  }
}
